import React from "react";
import { Grid, Typography } from "@mui/material";
import { Colors } from "../../constants/Colors";

//import { useAppContext } from "../../context/AppContext";

const Header = () => {
  //const { user = {} } = useAppContext();

  return (
    <Grid
      container
      alignItems={"center"}
      justifyContent={"space-between"}
      backgroundColor={Colors.white}
      p={"15px"}
      boxShadow={2}
    >
      <Grid item>
        <Typography
          fontFamily={"Poppins-Regular"}
          color={Colors.black}
          fontSize={20}
        >
          {"Welcome to "}<span style={{fontWeight:'bold'}}>{"AnitraAI Bank Application"}</span>
        </Typography>
      </Grid>
    </Grid>
  );
};

export default Header;
